import { Outlet } from "react-router-dom";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import LocataireCandidaturesList from "../../components/Locataire/LocataireCandidaturesList";

export default function LocataireListCandidaturesPage() {
  return (
    <>
      <ContentLayout
        header={
          <div
            className={
              "padding20 flex space-between align-items-end paddingB40"
            }
          >
            <div>
              <h2 className={"marginB0"}>Candidatures en cours</h2>
              <p className={"secondaryText"}>
                Visualisez ici toutes les candidatures que vous avez soumises
              </p>
            </div>
          </div>
        }
        body={<LocataireCandidaturesList />}
      />
      <Outlet />
    </>
  );
}
